import { render } from "./PlantIcon.vue?vue&type=template&id=318330c8"
import script from "./PlantIcon.vue?vue&type=script&lang=js"
export * from "./PlantIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__